import {routerMiddleware} from 'connected-react-router';
import promiseMiddleware from 'redux-promise-middleware';
import {configureStore, getDefaultMiddleware} from '@reduxjs/toolkit';
import {createReduxEnhancer} from '@sentry/react';

import history from 'utils/history';
import createRootReducer from './reducers';
import {analyticsMiddleware} from './middleware/analytics';
import facilityLocationMiddleware from './middleware/facility-sync-middleware';

/** @module store */

/**
 * The Sentry Redux enhancer. Documentation: {@link https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/redux/}
 */
const sentryReduxEnhancer = createReduxEnhancer();
const rootReducer = createRootReducer(history);

/**
 * Creates the redux store.
 */
export function createStore(initialState = {}) {
    const store = configureStore({
        reducer: rootReducer,
        middleware: () =>
            getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: false, // disabled due to timeouts in concourse
            }).concat(
                routerMiddleware(history),
                analyticsMiddleware.middleware,
                facilityLocationMiddleware.middleware,
                promiseMiddleware
            ),
        preloadedState: initialState,
        enhancers: [sentryReduxEnhancer],
    });

    return store;
}
const store = createStore();

export default store;

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
